import { render, staticRenderFns } from "./ProtectionGoalNiveau.vue?vue&type=template&id=74cabffb&"
import script from "./ProtectionGoalNiveau.vue?vue&type=script&lang=ts&"
export * from "./ProtectionGoalNiveau.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports